export const CREATE_TICKET = 'CREATE_TICKET';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';

export const SAVE_TICKET = 'SAVE_TICKET';
export const SAVE_TICKET_SUCCESS = 'SAVE_TICKET_SUCCESS';
export const SAVE_TICKET_FAILURE = 'SAVE_TICKET_FAILURE';
export const RESET_TICKET_SUCCESS = 'RESET_TICKET_SUCCESS';

export const GET_TICKET_LIST = 'GET_TICKET_LIST';
export const GET_TICKET_LIST_SUCCESS = 'GET_TICKET_LIST_SUCCESS';
export const GET_TICKET_LIST_FAILURE = 'GET_TICKET_LIST_FAILURE';

export const GET_TICKET_LIST_NEXT_FAILURE = 'GET_TICKET_LIST_NEXT_FAILURE';
export const GET_TICKET_LIST_NEXT_SUCCESS = 'GET_TICKET_LIST_NEXT_SUCCESS';
export const GET_TICKET_LIST_NEXT = 'GET_TICKET_LIST_NEXT';

export const GET_TICKET = 'GET_TICKET';
export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_FAILURE = 'GET_TICKET_FAILURE';

export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAILURE = 'ADD_COMMENT_FAILURE';

export const GET_CATEGORY_INFO = 'GET_CATEGORY_INFO';
export const GET_CATEGORY_INFO_SUCCESS = 'GET_CATEGORY_INFO_SUCCESS';
export const GET_CATEGORY_INFO_FAILURE = 'GET_CATEGORY_INFO_FAILURE';

export const CLOSE_ALERT = 'CLOSE_ALERT';

export const GET_TICKET_ACTION_TYPES = 'GET_TICKET_ACTION_TYPES';
export const GET_TICKET_ACTION_TYPES_SUCCESS = 'GET_TICKET_ACTION_TYPES_SUCCESS';
export const GET_TICKET_ACTION_TYPES_FAILURE = 'GET_TICKET_ACTION_TYPES_FAILURE';

export const CREATE_SMART_ACTION = 'CREATE_SMART_ACTION';
export const CREATE_SMART_ACTION_SUCCESS = 'CREATE_SMART_ACTION_SUCCESS';
export const CREATE_SMART_ACTION_FAILURE = 'CREATE_SMART_ACTION_FAILURE';

export const SAVE_SMART_ACTION = 'SAVE_SMART_ACTION';
export const SAVE_SMART_ACTION_SUCCESS = 'SAVE_SMART_ACTION_SUCCESS';
export const SAVE_SMART_ACTION_FAILURE = 'SAVE_SMART_ACTION_FAILURE';

export const DELETE_SMART_ACTION = 'DELETE_SMART_ACTION';
export const DELETE_SMART_ACTION_SUCCESS = 'DELETE_SMART_ACTION_SUCCESS';
export const DELETE_SMART_ACTION_FAILURE = 'DELETE_SMART_ACTION_FAILURE';

export const GET_COMMENTS_BY_TICKET_ID = 'GET_COMMENTS_BY_TICKET_ID';
export const GET_COMMENTS_BY_TICKET_ID_SUCCESS = 'GET_COMMENTS_BY_TICKET_ID_SUCCESS';
export const GET_COMMENTS_BY_TICKET_ID_FAILURE = 'GET_COMMENTS_BY_TICKET_ID_FAILURE';

export const FETCH_SMART_ACTION = 'FETCH_SMART_ACTION';
export const FETCH_SMART_ACTION_SUCCESS = 'FETCH_SMART_ACTION_SUCCESS';
export const FETCH_SMART_ACTION_FAILURE = 'FETCH_SMART_ACTION_FAILURE';

export const GET_TICKET_STATUS = 'GET_TICKET_STATUS';
export const GET_TICKET_STATUS_SUCCESS = 'GET_TICKET_STATUS_SUCCESS';
export const GET_TICKET_STATUS_FAILURE = 'GET_TICKET_STATUS_FAILURE';

export const SNOOZE_TICKET_REQUEST = 'SNOOZE_TICKET_REQUEST';
export const SNOOZE_TICKET_SUCCESS = 'SNOOZE_TICKET_SUCCESS';
export const SNOOZE_TICKET_FAILURE = 'SNOOZE_TICKET_FAILURE';

export const SET_ACTION_FOR_CREATING_ORDER = 'SET_ACTION_FOR_CREATING_ORDER';

export const UPDATE_OPERATIONS = 'UPDATE_OPERATIONS';

export const UPDATE_PARTS = 'UPDATE_PARTS';
export const CLEAR_PART_FIELD = 'CLEAR_PART_FIELD';

export const RESET_SMART_ACTION_SUCCESS = 'RESET_SMART_ACTION_SUCCESS';
